import { styled } from "@mui/material";
import { ComponentPropsWithRef } from "react";
import { defaultFocusOutline } from "../../../helpers/accessibility";

const StyledAnchor = styled("a")(({ theme }) => ({
  textDecoration: "none",
  color: "inherit",
  outline: 0,
  position: "relative",
  height: "100%",
  display: "block",
  borderRadius: "inherit",
  overflow: "hidden",
  "&:focus-visible": {
    outline: defaultFocusOutline(theme),
  },
}));

type Props = ComponentPropsWithRef<"a">;

export const NeutralAnchor = ({ children, ...props }: Props) => (
  <StyledAnchor {...props}>{children}</StyledAnchor>
);
